<template>
    <div class="add customer__form modal modal--default">
        <div class="modal__panel" style="min-height: 500px;">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
            </div>
            <div class="add__new">Import Leads</div>
            <div class="modal__main-icon modal__main-icon--leads"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <Loading v-if="loading" />
                <div v-else class="add__form import__form">
                    <div v-if="errorRows && errorRows.length == 0">
                        <div class="form__row team-row" v-if="userTeams && userTeams.length > 0">
                            <VSelect class="select select--default" :class="{ 'select--error': teamHasError }"
                                :options="userTeams" label="name" :reduce="(team) => team.id"
                                @input="getFiltersData($event)" :placeholder="$t('settingsPage.selectTeamPlaceholder')"
                                v-model="teamId" />
                            <div class="form__error" v-if="teamHasError">
                                {{ $t(`addTeamModal.${"teamIdErrorMsg"}`) }}
                            </div>
                        </div>
                        <div class="form__row team-row" v-if="userTeams && userTeams.length > 0 && teamId">
                            <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                                :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`
                                    " :placeholder="$t('policyProvision.agent')" v-model="agentId" />
                        </div>

                        <div class="form__row" v-if="userTeams && userTeams.length > 0 && teamId">
                            <DropFile @input="handleFileUpload" />
                        </div>

                        <div class="form__row sample">
                            <a href="/leads_import_sample.xlsx" class="btn">{{ $t(`settingsPage.${"downloadSample"}`) }}</a>
                        </div>
                    </div>
                    <div v-else class="error-table-wrapper">
                        <h4 class="form__title">Import Errors ({{ errorRows.length }})</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Row</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"name"}`) }}</th>
                                    <th>Type</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"zipCode"}`) }}</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"city"}`) }}</th>
                                    <th>{{ $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"category"}`) }}</th>
                                    <th>{{ $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"referal"}`) }}</th>
                                    <th>{{ $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"referalNote"}`) }}</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"deadline"}`) }}</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"status"}`) }}</th>
                                    <th>{{ $t(`leads.${"tableHeader"}.${"text"}`) }}</th>
                                    <th>Error</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in errorRows" :key="index">
                                    <td>{{ row.row }}</td>
                                    <td>{{ row.vorname }} {{ row.nachname }}</td>
                                    <td>{{ row.typ }}</td>
                                    <td>{{ row.email }}</td>
                                    <td>{{ row.telefon }}</td>
                                    <td>{{ row.plz }}</td>
                                    <td>{{ row.stadt }}</td>
                                    <td>{{ row.kategorie }}</td>
                                    <td>{{ row.verweisung }}</td>
                                    <td>{{ row.empfehlungshinweis }}</td>
                                    <td>{{ row.frist }}</td>
                                    <td>{{ row.status }}</td>
                                    <td>{{ row.text }}</td>
                                    <td class="error-message">{{ row.error }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div v-if="isRequesting"
                    class="modal__button modal__button--submit button button--default button--loading">
                </div>
                <div v-else>
                    <div v-if="downloadOrClose">
                        <button class="modal__button modal__button--submit button button--default"
                            @click="downloadErrorRows(errorRows)" style="right: 240px;">
                            <span>Download</span>
                        </button>
                        <button class="modal__button modal__button--submit button button--default"
                            @click="closeModal()">
                            <span>Close</span>
                        </button>
                    </div>

                    <button v-else class="modal__button modal__button--submit button button--default"
                        @click="importLeads()">
                        <span>Import</span>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import DropFile from './DropFile.vue';
import api from "@/api";
import * as XLSX from 'xlsx';

import Loading from "@/partials/Loading";
export default {
    name: "LeadImportModal",
    components: {
        DropFile,
        Loading
    },
    data() {
        return {
            teamId: null,
            agentId: null,
            loading: false,
            teamHasError: false,
            isRequesting: false,
            uploadedFile: null,
            errorRows: [],
            downloadOrClose: false,
        };
    },
    watch: {
        teamId(value) {
            this.teamHasError = !value;
        },
    },
    computed: {
        ...mapGetters([
            'userForms',
            "loggedUser",
            "searchLeadForms"
        ]),

        

        userTeams() {
            if (!this.loggedUser || !this.loggedUser.teams) return [];
            return this.loggedUser.teams;
        },

        agents() {
            if (!this.searchLeadForms || !this.searchLeadForms.agents) return [];
            return this.searchLeadForms.agents;
        },
    },
    methods: {
        async getFiltersData(teamIds) {
            this.loading = true;
            if (teamIds != null) {
                await this.$store.dispatch("getSearchLeadForms", teamIds);
            }
            this.loading = false;
        },

        async importLeads() {
            if (!this.teamId) {
                this.teamHasError = true;
                return;
            }

            if (!this.uploadedFile) {
                this.$store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: this.$t(`leadsImportMessages.noFile`),
                });
                return;
            }

            try {
                this.isRequesting = true;

                const formData = new FormData();
                formData.append('team_id', this.teamId);
                if (this.agentId) {
                    formData.append('agent_id', this.agentId);
                }
                formData.append('file', this.uploadedFile);

                const response = await api({
                    requiresAuth: true,
                }).post('/v1/import-lead-customers', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                this.errorRows = response.data.error_records || [];

                const importedCount = (
                    response.data.imported_count ?? 
                    response.data.imported ?? 
                    (response.data.total_records ? response.data.total_records - this.errorRows.length : null)
                );
 
                if (importedCount !== null && importedCount > 0) {
                    await this.$store.dispatch("fetchLeadCustomers", 1);
                }

                if (this.errorRows.length > 0) {
                    let message = '';
                    if (importedCount !== null && importedCount > 0) {
                        message = `${importedCount} ${this.$t(`leadsImportMessages.success`)} ${this.errorRows.length} ${this.$t(`leadsImportMessages.failedToImport`)}`;
                    } else {
                        message = `${this.errorRows.length} ${this.$t(`leadsImportMessages.failedToImport`)}`;
                    }

                    this.$store.commit("setToast", {
                        display: true,
                        type: 'error',
                        message,
                    });

                    this.downloadOrClose = true;
                } else {
                    this.$store.commit("setToast", {
                        display: true,
                        type: "success",
                        message: response.data.message || this.$t(`leadsImportMessages.success`),
                    });
                    await this.closeModal();
                }

            } catch (error) {
                const errorData = error.response?.data?.message || this.$t(`leadsImportMessages.error`);
                this.$store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: errorData,
                });
            } finally {
                this.isRequesting = false;
            }
        },


        ////
        handleFileUpload(files) {
            if (this.teamId !== null) {
                const file = files[0].file;
                if (file) {
                    if (!this.isValidCSV(file)) {
                        this.$store.commit("setToast", {
                            display: true,
                            type: "error",
                            message: this.$t(`leadsImportMessages.invalidFile`),
                        });
                        return;
                    }

                    // Store the file for upload
                    this.uploadedFile = file;

                    this.$store.commit("setToast", {
                        display: true,
                        type: "success",
                        message: this.$t(`leadsImportMessages.fileUploadedSuccess`),
                    });

                    this.showInputFile = false;
                }else {
                    this.$store.commit("setToast", {
                        display: true,
                        type: "error",
                        message: this.$t(`leadsImportMessages.noFile`),
                    });
                }
            } else {
                this.$store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: this.$t(`leadsImportMessages.noTeam`),
                });
            }
        },

        isValidCSV(file) {
            const validTypes = [
                'text/csv',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            if (!validTypes.includes(file.type)) {
                return false;
            }

            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                return false;
            }

            return true;
        },

   
        downloadErrorRows(errorRows) {
            const rows = errorRows.length
                ? errorRows : this.errorRows;

            if (!rows.length) return;

            let sheetData = [
                ["Name", "Type", "Email", "Phone", "PLZ", "Stadt", "Kategorie", "Empfehlung", "Empfehlungshinweis", "Frist", "Status", "Text", "Error"]
            ]; 

            rows.forEach(item => { 
                sheetData.push([
                    item.vorname + " " + item.nachname,
                    item.typ,
                    item.email,
                    item.telefon,
                    item.plz,
                    item.stadt,
                    item.kategorie,
                    item.verweisung,
                    item.empfehlungshinweis,
                    item.frist,
                    item.status,
                    item.text,
                    item.error,
                ]);
            }); 

            const ws = XLSX.utils.aoa_to_sheet(sheetData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Error Rows");


            const now = new Date();
            const date = now.toLocaleDateString("en-GB").replace(/\//g, "-");
            const time = now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }).replace(":", "-");

            const fileName = `leads_error_rows_(${date})(${time}).xlsx`;

            XLSX.writeFile(wb, fileName);
        }, 
  
 
        async closeModal() { 
            this.$store.commit('setShowLeadImportModal', false);
        },

    },
    async mounted() {
        if (!this.$checkRolePermission('customer_create')) {
            this.closeModal();
        } else {
            this.loading = true;
            await this.$store.dispatch("getUserForms");
            this.teams = this.userForms.teams;
            this.loading = false;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_add-panel-modal.scss";

.sample{
    margin-top: 30px;
}

 
.modal {
    .import__form {
        width: 100% !important;
        margin-top: 20px !important; 
    }

    .form__row {
        justify-content: center;
    }

    &__panel {
        height: auto !important;
        width: 75%;
    }
}

.team-row {
    width: 30%;
    margin: 20px auto;

    flex-direction: column;

}

.form__error {
    position: initial !important;
    margin-top: 5px;
}

.error-table-wrapper {
    width: 100%;
    margin-top: 50px;
    overflow: auto;
    max-height: 19em; 
}

.form__title {
    color: #FFA500;
    font-weight: normal;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 20px;
    border-spacing: 6px 0px;
    table-layout: fixed;
}

th,
td {
    padding: 12px 8px;
    text-align: left;
    background-color: #fff;
    box-shadow: 0px 0px 10px #0000000D;
    border-bottom: 1px solid #DADCDE;
    border-radius: 0px;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    
    &:nth-child(1) { width: 47px; }  /* Row */
    &:nth-child(2) { width: 120px; } /* Name */
    &:nth-child(3) { width: 88px; }  /* Type */
     // &:nth-child(4) { width: 150px; } /* Email */
    // &:nth-child(5) { width: 120px; } /* Phone */
    // &:nth-child(6) { width: 50px; }  /* PLZ */
    // &:nth-child(7) { width: 90px; } /* Stadt */
    // &:nth-child(8) { width: 100px; } /* Kategorie */
    //  &:nth-child(9) { width: 95px; } /* Verweisung */
    // &:nth-child(10) { width: 90px; } /* Frist */
    // &:nth-child(11) { width: 100px; } /* Status */
    // &:nth-child(12) { width: 120px; } /* Text */
    &:nth-child(14) { 
        width: 200px;  /* Error - wider column */
    }
}

td { 
    letter-spacing: 0px;
    color: #7F8FA4;
}

tr:first-child th {
    border-radius: 8px 8px 0px 0px;
}

tr:last-child td {
    border-radius: 0px 0px 8px 8px;
    border: none;
}

th {
    color: #22DB8E;
    font-weight: normal;
    font-size: 14px;
}

tbody tr+tr td {
    margin-top: 15px;
}

tbody tr:hover td {
    background-color: #f1f1f1;
}

.error-message {
    white-space: normal !important;
    word-break: break-word;
    color: #d9534f; 
    overflow: visible !important;
    text-overflow: initial !important; 
}

[data-theme="dark"] tr th,
[data-theme="dark"] tr td {
    background: var(--bg-17) !important;
}

[data-theme="dark"] tr td,
[data-theme="dark"] .form__title,
[data-theme="dark"] .sample a {
    color: white !important;
}
 
</style>